import { adminFetch } from "./base";

export interface AppConfigEntry {
  readonly key: string;
  readonly value: string;
  readonly description: string | null;
}

export interface TaxConfigEntry {
  readonly id: string;
  readonly name: string;
  readonly rate: number;
  readonly active: boolean;
}

export interface ConfigResponse {
  readonly app_config: readonly AppConfigEntry[];
  readonly tax_config: readonly TaxConfigEntry[];
}

export const configApi = {
  get: () => adminFetch<ConfigResponse>("/api/admin/config"),
  update: (data: {
    app_config?: Array<{ key: string; value: string | number | boolean }>;
    tax_config?: Array<{ id: string; rate: number; active: boolean }>;
  }) =>
    adminFetch<{ readonly success: boolean }>("/api/admin/config", {
      method: "PATCH",
      body: JSON.stringify(data),
    }),
} as const;
